
export const ptlEnvs = {
    base: `${process.env.REACT_APP_BASE_PTL}`,
};

/*
 * 프로젝트별 공통기능(함수) 사용시 작성
 */
export const ptlUtils = { };
